import { ChangeEvent, ReactNode } from 'react';
import { DEFAULT_USER_ROLES, DEFAULT_AUTH_FLOWS } from './../variables';
import { AuthContext } from 'utilities/contexts/auth';

export enum AuthStatus {
  Loading,
  SignedIn,
  SignedOut,
}

export interface IAuth {
  sessionInfo?: { username?: string; identifier?: string; sub?: string; accessToken?: string; refreshToken?: string },
  userProfile?: any
  attrInfo?: any
  authStatus?: AuthStatus
  signInEmailOnly?: any
  signInUsernamePassword?: any
  signUpWithEmail?: any
  signOut?: any
  verifyCode?: any
  getSession?: any
  refreshSessionInfo?: any
  sendCode?: any
  forgotPassword?: any
  changePassword?: any
  getAttributes?: any
  setAttribute?: any
  getApiSessionTokens?: any
  getAmplifyCurrentAthenticatedUser?: any,
  authFlow: DEFAULT_AUTH_FLOWS.EMAIL_ONLY | DEFAULT_AUTH_FLOWS.EMAIL_PASSWORD,
  // userKeys?: bsgCrypto.CryptoData
}

export interface RefDataItem {
  keywords: string[];
  description: string;
  id: string;
  url: string;
  name: string;
}

export interface APIRegions {
  id: string;
  name: string;
  provider: string;
  enabled: boolean;
}

export interface IntToolTip {
    id: number;
    image: string;
    title: string;
    description: string;
}

export interface IViewport {
  vpProductIndex: number;
  isRunning: boolean;
  viewportProducts: IViewportProducts[];
}

export interface IViewportFullWindow {
  product: any;
  isRunning: boolean;
  productUrl: string;
}

export interface IViewportMobileFullWindow {
  product: any;
  isRunning: boolean;
  productUrl: string;
  products: any;
  setShowLocationModal: any;
}


export interface IViewportProducts {
  isRunning: boolean;
  url: string;
  id: string;
  name?: string;
  number?: string;
  parameters?: any;
  meta?: any;
}

export interface IntOption {
  id: number;
  type: string;
  selected: boolean;
  image: string;
  title: string;
  description: string;
  metadata: string;
  tooltip: IntToolTip;
  fee: number;
  metaOne?: string;
  metaTwo?: string;
}

export interface IntLocOption {
  id: number;
  image: string;
  shortTitle: string;
  country: string;
  city: string;
  description: string;
  tooltip: IntToolTip;
  fee: number;
}

export interface IntProduct {
  id: number;
  shortTitle: string;
  image: string;
  header: string;
  title: string;
  type: string;
  description: string;
  version: string;
  published: string;
  tooltip: IntToolTip;
  baseFee: number;
  defaultOS: number;
  defaultLoc: number;
  defaultDuration: number;
  defaultCloud: number;
  defaultSize: number;
  osOptions: IntOption[];
  locOptions: IntOption[];
  choiceOptionsC: IntOption[];
  cloudOptions: IntOption[];
  sizeOptions: IntOption[];
  storageOptions: IntOption[];
  statusOption?: IntOption;
  metadataOne: string;
}

//aws_eu-west-2_vm_windows_standard_large_80
export interface IntApiProduct {
  id: string;
  cloud: string;            //aws
  region: string;           //eu-west-2
  type: string;             //vm
  subTypeVersion: string;   //windows
  prodMetaDataOne: string;  //standard
  prodMetaDataTwo: string;  //large
  prodMetaDataThree: string;  //large
  minutes: number;          //15
  name: string;             //Research DesktopproductsCatalogue
  shortTitle: string;       //WI

}

export interface IntPurchasedProduct {
  id: number;
  shortTitle: string;
  header: string;
  image: string;
  title: string
  type: string;
  description: string;
  version: string;
  published: string;
  tooltip: IntToolTip;
  baseFee: number;
  defaultOS: number;
  defaultLoc: number;
  defaultDuration: number;
  defaultCloud: number;
  defaultSize: number;
  osOption: IntOption;
  locOption: IntOption;
  choiceOptionC: IntOption;
  cloudOption: IntOption;
  sizeOption: IntOption;
  storageOptions: IntOption;
  statusOption: IntOption;
  metadataOne: string;
}

export interface IntProdStatus {
  state: string;
  bShadow: string;
  pointer: string;
}

export interface IModal {
  title: string;
  status: boolean;
  setShow: (show: boolean) => void;
  prodId: string;
  prodStatus?: string;
  prodShare?: any;
  prodName?: string;
  callback?: (id?: string, status?: string, statusText?: string, message?: string, timeout?: number) => void;
  productTags?: any;
}

export interface IGenericPromptModalContent {
  title: string;
  loadingMessage?: string;
  loadedMessage?: string;
  product: IGenericPromptModalContentProduct;
}

export interface IGenericPromptModalContentProduct {
  name?: string;
  id: string;
  state?: string;
  shareUrl?: string
  isRunning?: boolean;
}

export interface IGenericPromptModal {
  isVisible: boolean;
  content: IGenericPromptModalContent;
  handleModalHide: () => void;
  handleModalPromptConfirm?: () => void;
}

export interface ConfirmReleaseModalProps {
  show: boolean;
  number: string;
  onClose: () => void;
  onConfirm: (input: string) => void;
}

export interface IProductPresignedLinkModal extends IGenericPromptModal {
  handleGeneratePresignedUrl: () => Promise<string>;
}

export interface IntApiTag {
  [key: string]: string; 
}

export interface IntApiShare {
  [key: string]: string; 
}

export interface IApiProduct {
  'id': string;
  'product-code': string;
  'expiry': number;
  'state': string;
  'tags': IntApiTag;
  'share': IntApiShare;
  'parameters': any;
  'meta': any;
  'progress': any;
   os?:any;
   region?: any;
   provider?: any;
   instanceType?: any;
   category?: any;
   sizeValue?: any;
   capacity?: any;
}

export interface IntSubSetting {
  id: number;
  shortTitle: string;
  image: string;
  title: string;
  description: string;
}

export interface IntProductsDropdownAddProps {
  setIsAddingProduct: (value: boolean) => void,
  transformProduct: (product: IntProduct) => IntPurchasedProduct,
  setPurchasedProducts: (products: any) => void,
  setAddProductPulse: (value: boolean) => void,
  handleProductQuickLaunch: (query: any) => void
}

export interface IntDashboardWalletWidgetProps {
  balance: number,

  setIsAddingFunds: (value: boolean) => void,
  setBalance: (value: number) => void,
  setAddBalancePulse: (value: boolean) => void,
  
}

export interface IntProductDraggableProps {
  product: IntPurchasedProduct, 
  eventKey: string, 
  onStatusChange: (productId: number, newStatus: string, newTitle: string, newDesc: string, newFee: number) => void,
  addProductPulse: boolean,
}

export interface IProductDraggable {
  product: IApiProduct,
  eventKey: string, 
  handleProductStatusChange: (productId: string, newStatus: string, newTitle: string, newDesc: string, newFee: number) => void,
  addProductPulse: boolean,
  handleNewWindowOpen: (event: any) => void,
  cleanViewport: (prodID: string) => void;
  forceUpdate: () => void;
}

export interface IProductCard {
  product: IApiProduct
}

export interface IntDropdown {
  options: IntOption[];
  handleProductConfigure: (callback: any) => any;
}

export interface IntCustomToggle {
  dropType: IntOption[];
  eventKey: any;
  handleProductConfigure: (callback: any) => any
}

export interface ProductsPanelProps {
  data: IntPurchasedProduct[];
  eventKey: any;
  addProductPulse: boolean;
  purchasedProducts: IntPurchasedProduct[];
  setAddBalancePulse: (value: boolean) => void;
  setIsAddingProduct: (value: boolean) => void;
  transformProduct: (product: IntProduct) => IntPurchasedProduct;
  setPurchasedProducts: (products: any) => void;
  setAddProductPulse: (value: boolean) => void;
}

export interface IntApiProductsPanelProps {
  data: IntPurchasedProduct[];
  apiData: IApiProduct[];
  eventKey: any;
  addProductPulse: boolean;
  purchasedProducts: IntPurchasedProduct[];
  setAddBalancePulse: (value: boolean) => void;
  setIsAddingProduct: (value: boolean) => void;
  transformProduct: (product: IntProduct) => IntPurchasedProduct;
  setPurchasedProducts: (products: any) => void;
  setAddProductPulse: (value: boolean) => void;
  mediaControl: IntDashboardProductMediaControl;
  handleProductQuickLaunch: (quickProd: any) => void;
  cleanViewport: (prodID: string) => void;
  forceUpdate: () => void;
}

export interface IntUserGroupsPannelProp {
  data: any[];
  eventKey: any;
  callback: (value: any) => void;
  authContext?: React.ContextType<typeof AuthContext>;
}

export interface IntDashboardProductMediaControl {
  handleProductStatusChangeApi: (product: any) => void;
  handleNewWindowOpen: (event: any) => void;
}
export interface IntSettingsPanelProps {
  data: IntPurchasedProduct;
  eventKey: any;
  setShowViewport: (value: number) => void;
} 

export interface IntSubSettingToggleProps {
  data: IntSubSetting;
  eventKey: any;
  setShowViewport: (value: number) => void;
}  

export interface IntProductToggleProps {
  data: IntPurchasedProduct;
  eventKey: any;
}  

export interface IntCartDroppable {
  src: string[];
  vp: number;
}

export interface IntChatBotPanel {
  src: string;
  isUserAuthed: boolean;
}

export interface chatLens {
  lensName: string;
  lensDescription: string;
  lensGeneralInstructions: string;
  documents: string[];
  lensDocumentInstructions: string;
  isUserAuthed: boolean;
}

export interface IntProductWindowChatBotWIP {
  productId: string;
  messages: ChatbotMessage[]; 
  currentUserInput: string;
  handleUserInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleSendUserMessage: () => Promise<void>;
}

export interface IntProductWindowChatBot {
  productId: string;
  isUserAuthed: boolean;
}

export interface IntChatMenuData {
  icon: string;
  label: string;
  data: any;
  position: {top: number, left: number};
}

export interface IntChatMessageDynamic {
  sender: 'user' | 'bot';
  content: string;
  time?: string;
}

export interface IntMenuPopup {
  menuData: IntChatMenuData;
  isUserAuthed: boolean;
}


export interface IntMenu {
  prod: any;
  vp: number;
  url: string;
}
export interface IViewportMenu {
  productID: string;
  products: any;
  url: string;
  isUserAuthed: boolean;
  handleProductStatusChange: (product: { id: string, newStatus: string}) => Promise<void>;
  cleanViewport: (prodID: string) => void;
  forceUpdate: () => void;
}

export interface IProductWindowMenuControls {
  product: any;
  isRunning: boolean;
  isLoading: boolean;
  isOverlayVisible: boolean;
  productUrl: string;
  menuTab: string;
  isUserAuthed: boolean;
  handleProductPause: () => Promise<void>;
  handleProductStop: () => Promise<void>;
  handleProductStart: () => Promise<void>; 
  handleProductClose: () => Promise<void>; 
  handleShowProductTerminateModal: () => void;
  handleShowProductPresignedLinkModal: () => void;
  handleShowProductUserShareModal: (event: any) => void;
  handleShowProductGroupShareModal: (event: any) => void;
  handleShowProductSetScreenSizeModal: (event: any) => void;
  handleShowProductSetSecurityGroupModal: (event: any) => void;
  handleShowProductShowPasswordModal: (event: any) => void;
  handleToggleOverlayVisible: () => void;
  handleMenuTabChange: (selectedKey: string) => void;
}

export interface ChatbotMessage {
  sender: 'user' | 'bot';
  content: string;
}

export interface IntMainsearchProps {
  setShowTopSearchBar: React.Dispatch<React.SetStateAction<boolean>>;
  // Include other properties as needed...
}

export interface IApiHandledResponse {
  status: string;
  body?: any;
  errorMessage?: any
}

export interface IAuthHandledResponse {
  status: string;
  body?: any;
  errorMessage?: any
}

export interface IntUserInitials {
  input: string | null | undefined;
  backgroundColor?: string;
  width?: string;
  height?: string;
  fontSize?: string;
  border?: string;
  color?: string;
  marginRight?: string;
}

export interface IAccountInformationData {
  id: string;
  identifier: string;
  name?: IAccountInformationName;
  display_name?: string;
  phone?: string;
  profile_photo?: IAccountInformationProfilePhoto
}

export interface IAccountInformationName {
  first?: string;
  last?: string;
  middle?: string;
}

export interface IAccountInformationFormData {
  firstName?: string;
  lastName?: string;
  middleName?: string;
  displayName?: string;
  phone?: string;
}

export interface IAccountInformationProfilePhoto {
  custom_file_name: string;
  custom_photo: string;
}

export interface IAccountInformation {
  userAttributes: IAccountUserAttributes;
  handleUserAccountFormSubmit: (body: IAccountInformationData) => Promise<void>
}

export interface IAccountUserAttributes {
  identifier: string;
  email?: string;
  id: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  displayName?: string;
  phone?: string;
  role: DEFAULT_USER_ROLES.ADMINISTRATOR | DEFAULT_USER_ROLES.USER | DEFAULT_USER_ROLES.SUPERADMINISTRATOR;
}

export interface IUserListAttributes {
  id: string;
  name: {
    last: string;
    first: string;
    middle: string;
  };
  display_name: string;
}

export interface IGroupListAttributes {
  id: string;
  name: string;
}

export interface IntSuspenseLoader {
  component: React.LazyExoticComponent<() => JSX.Element>| any;
}

export interface IntRouteDefinitions {
  setShowTopSearchBar: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface IntMobileRouteDefinitions {
  setShowTopSearchBar: React.Dispatch<React.SetStateAction<boolean>>;
  mobileEnabled:boolean;
}

export interface IntProfileDropdown {
  userAttributes: IAccountUserAttributes;
  handleSignOut: (event: React.MouseEvent) => Promise<void>;
}

export interface TipProps {
  id: string;
  children: ReactNode;
  title: string;
}

export interface ProductContent {
  type: string;
  content: {
    product: string;
    share: { SS: string[] };
    dns: { remap_on_start: boolean; machine: string; domain: string };
    user: string;
    cloud_ids: { [key: string]: string };
    state: string;
    ipv6: string;
    parameters: { [key: string]: string };
    meta: { [key: string]: string };
    ipv4: string;
    provider: string;
    metrics: { id: string };
    region: string;
    id: string;
    tags: { [key: string]: string };
    'product-code': string;
  };
}

export interface ProductMessage {
  message_id: string; 
  sender: string;
  delivered: boolean;
  clean_text: string;
  received_at: string;
  destination: string;
  time_epoch: number;
  product_id: string;
}

export interface DeploymentSettings {
  DEPLOYMENT_NAME: string;
  DOMAIN_URL: string;
  ADDITIONAL_DOMAINS?: string[];
  WEB_APP_URL: string;
  LAMBDA_API_URL: string;
  WEB_SOCKET_ENDPOINT: string;
  AUTO_HIBERNATE: boolean;
  FILE_EXPLORER: boolean;
  ADMIN_USERS: boolean;
  ADMIN_PRODUCTS: boolean;
  ADMIN_PLATFORM: boolean;
  SEARCH: boolean;
  REFERENCE: boolean;
  VPN: boolean;
  KAI: boolean;
  ENFORCE_SCREEN: boolean;
  DEFAULT_SCREEN_W: number;
  DEFAULT_SCREEN_H: number;
  DEFAULT_HIBERNATION_TIME: number;
  ENVIRONMENT: string;
  SUPPORT: string;
  BRANDING: string;
  ENABLE_USERNAME: boolean;
  ENABLE_NUMBER: boolean;
  SECURE_CP: boolean;
  GROUPS: boolean;
  DEFAULT_AVD_NUMBER: number;
  VNUMBER: boolean;
  AVDEVICE: boolean;
  WINDESKTOP: boolean;
  UBUNDESKTOP: boolean;
}

export type VpnCredentialsMap = Map<number, [username: string, password: string]>;

export interface IVpnItem {
  name: string;      // e.g. "1"
  username: string;  // e.g. "user1"
  password: string;  // e.g. "pass1"
}

export interface IOpenConfig {
  ENVIRONMENT?: string;
  COGNITO_USERPOOL_ID?: string;
  COGNITO_CLIENT_ID?: string;
  DOMAIN_URL?: string;
  WEB_SOCKET_ENDPOINT?: string;
  AUTHENTICATION_FLOW?: string;
  WEB_APP_URL?: string;
  LAMBDA_API_URL?: string;
  BRANDING?: string;
  MOBILEINTERFACE?: boolean;
}

export type Country = {
  name: string;
  dial_code: string;
  code: string;
};

export type Limits = {
  android?: string | number;
  desktop?: string | number;
  vm?: string | number;
  [k: string]: unknown;
};

export type UserContent = {
  id: string;
  name: { first: string; last: string; middle: string };
  display_name: string;
  identifier: string;
  email: string;
  phone: string;
  role: 'user' | 'administrator' | 'superadministrator';
  enabled: boolean;
  mfa: string;
  auth_method: string;
  limits?: Limits;
  [k: string]: unknown;
};

export type License = {
  id?: string;
  status?: string;
  reference?: string;
  purchaseDate?: string;
  renewalDate?: string;
  userID?: string;
  userEmail?: string;
  userBU?: string;
  licenseType?: string;
  licenseTypeValue?: string;
  licenseTypeNotes?: string;
};

export const licenseTypes = [ 'Kuro License', 'Android License', 'Desktop License', 'Identity Base', 'Identity Developed', 'Number License' ];
export const licenseStatus = [ 'active', 'suspended', 'cancelled' ];